import { asPage } from 'src/components/hoc/asPage'
import { Messages } from 'src/compositions/Messages'

export default asPage(Messages, { pageTitle: '決裁者メッセージ' })
